import { render, staticRenderFns } from "./PopupDetailsParcel.vue?vue&type=template&id=e481636a&"
import script from "./PopupDetailsParcel.vue?vue&type=script&lang=js&"
export * from "./PopupDetailsParcel.vue?vue&type=script&lang=js&"
import style0 from "./PopupDetailsParcel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports